<template>
  <div>
    <el-drawer v-loading="loading" title="活动详情" :visible.sync="show" size="50%" @close="close">
      <div class="padding-x-25">
        <p class="title">
          <span class="margin-left-10" style="vertical-align: middle">基本信息</span>
        </p>
        <div class="flex-start font-14 margin-bottom-20">
          <span class="font-20 font-weight color-redFont margin-right-5">*</span>
          <span>活动名称：</span>
          <span>{{ detail.name || '' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span class="font-20 font-weight color-redFont margin-right-5">*</span>
          <span>活动时间：</span>
          <span>{{ detail.startTime || '' }} 至 {{ detail.endTime || '' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>隶属公司：</span>
          <span class="f-1">
            {{ detail.shiFouSuoYouXianLu === 1 ? '全部' : detail.merchantNames }}
          </span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>可用线路：</span>
          <span class="f-1">{{ detail.shiFouSuoYouXianLu === 1 ? '全部' : detail.lineNames }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span class="font-20 font-weight color-redFont margin-right-5">*</span>
          <span>可参与订单数：</span>
          <span>{{ detail.huoDongCiShu || 0 }}</span>
          <span>，剩余：{{ detail.shengYuHuoDongCiShu || 0 }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span class="font-20 font-weight color-redFont margin-right-5">*</span>
          <span>预算金额：</span>
          <span>{{ detail.huoDongZongJinEYuan || '0.00' }}元</span>
          <span>，剩余{{ detail.shengYuhuoDongJinEYuan || '0.00' }}元</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>使用条件：</span>
          <span>{{ detail.withNewUser ? '仅新用户可用' : '-' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>是否可重复参与：</span>
          <span>{{ detail.shiFouChongFu ? '可重复参与' : '不可重复参与' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>与优惠券互斥：</span>
          <span>{{ detail.withCoupon ? '互斥' : '不互斥' }}</span>
        </div>
        <div class="flex-top font-14 margin-bottom-20">
          <span style="line-height: 26px">使用说明：</span>
          <div style="white-space: pre-line; line-height: 26px" v-html="detail.describe"></div>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span style="line-height: 26px">扫码补票是否可用：</span>
          <span>{{ detail.buPiaoShiFouKeYong === 1 ? '是' : '否' }}</span>
        </div>

        <div class="flex-start font-14 margin-bottom-20">
          <span style="line-height: 26px">是否关联渠道码：</span>
          <span>{{ detail.enableChannelCode === 1 ? '是' : '否' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20" v-if="detail.enableChannelCode === 1">
          <span style="line-height: 26px">关联渠道码：</span>
          <span>{{ channelIdList }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20" v-if="detail.enableChannelCode === 1">
          <span style="line-height: 26px">活动规则：</span>
          <span v-html="detail.activityRule"></span>
        </div>

        <p class="title">
          <span class="margin-left-10" style="vertical-align: middle">优惠条件</span>
        </p>
        <div class="flex-start font-14 margin-bottom-10">
          <div>
            <span class="font-20 font-weight color-redFont margin-right-5">*</span>
            <span>优惠条件：</span>
          </div>
          <div v-if="detail.tiaoJian === 1">
            <span class="margin-left-5 margin-right-10">金额</span>
            <span>满**元可用</span>
            <!--  <span>{{detail.huoDongCiShu || 0}}</span>
            <span>，剩余：{{detail.shengYuHuoDongCiShu || 0}}</span> -->
          </div>
          <div v-if="detail.tiaoJian === 2">
            <span class="margin-left-5 margin-right-10">人数</span>
            <span>满**人可用</span>
            <!--  <span>{{detail.huoDongCiShu || 0}}</span>
            <span>，剩余：{{detail.shengYuHuoDongCiShu || 0}}</span> -->
          </div>
        </div>
        <div
          class="padding-left-20 font-14"
          v-if="detail.activityLiJianItemVoList && detail.activityLiJianItemVoList.length > 0"
        >
          <div
            v-for="(item, index) in detail.activityLiJianItemVoList"
            class="flex-start margin-bottom-10"
            :key="item.activityLiJianId"
          >
            <div v-if="detail.tiaoJian === 1">
              <!-- 满钱 -->
              层级{{ index + 1 }}：
              <template v-if="detail.youHuiNeiRong === 1">
                满{{ item.topMoney }}元，减{{ item.liJianMoney }}元
              </template>
              <template v-if="detail.youHuiNeiRong === 2">
                满{{ item.topMoney }}元，打{{ item.zheKou }}折，最高优惠{{ item.maxYouHuiMoney }}元
              </template>
            </div>
            <div v-if="detail.tiaoJian === 2">
              <!-- 满人 -->
              层级{{ index + 1 }}：
              <template v-if="detail.youHuiNeiRong === 1">
                满{{ item.topPeople }}人，减{{ item.liJianMoney }}元
              </template>
              <template v-if="detail.youHuiNeiRong === 2">
                满{{ item.topPeople }}人，打{{ item.zheKou }}折，最高优惠{{ item.maxYouHuiMoney }}元
              </template>
            </div>
          </div>
        </div>
        <p class="title">
          <span class="margin-left-10" style="vertical-align: middle">其他</span>
        </p>
        <div class="flex-between flex-1 padding-right-30">
          <div class="flex-start font-14 margin-bottom-20">
            <span>创建人：</span>
            <span>{{ detail.createUserName || '' }}</span>
          </div>
          <div class="flex-start font-14 margin-bottom-20">
            <span>创建时间：</span>
            <span>{{ detail.createTime || '' }}</span>
          </div>
        </div>
        <div class="flex-between flex-1 padding-right-30">
          <div class="flex-start font-14 margin-bottom-20">
            <span>审核人：</span>
            <span>{{ detail.shenHeUserName || '' }}</span>
          </div>
          <div class="flex-start font-14 margin-bottom-20">
            <span>审核时间：</span>
            <span>{{ detail.shenHeTime || '' }}</span>
          </div>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>活动状态：</span>
          <span>{{ detail.stateStr || '' }}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-20">
          <span>不通过原因：</span>
          <span>{{ detail.shenHeRemark || '-' }}</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import { getAcDetail } from '@/api'
  export default {
    name: 'detail',
    data() {
      return {
        show: false,
        loading: false,
        detail: {},
        channelIdList: ''
      }
    },
    created() {},
    mounted() {},
    methods: {
      close() {
        this.show = false
      },
      async getDetail(item) {
        this.show = true
        this.loading = true
        const { code, data } = await getAcDetail({
          no: item.activityLiJianNo
        })
        this.loading = false
        if (code === 0) {
          this.detail = data
          if (this.detail.enableChannelCode === 1) {
            let str = ''
            this.detail.channelList.forEach((item) => {
              str += item.name + ','
            })
            this.channelIdList = str.substring(0, str.length - 1)
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .title {
    margin: 0 0 10px;
    font-size: 16px;
    font-weight: 700;

    &:before {
      content: '';
      width: 4px;
      height: 16px;
      display: inline-block;
      background: #1089ff;
      vertical-align: middle;
    }
  }
  .f-1 {
    flex: 1;
    width: 0;
  }
</style>
